import styled from "styled-components";
import { Heading } from "@viagogo/core/ui";
import { Content } from "src/shared/components/content";
import { CarouselSkeleton } from "src/website-apps/responsive/stubhub-home/components/LazyCarouselSection";
import { CarouselId } from "src/website-apps/shared/components/carousel-module/carousel-analytics-event";
import { FavoriteEventsCarousel } from "src/website-apps/shared/components/FavoriteEventsCarousel";
import { ENTITY_TYPES } from "src/website-apps/shared/components/grid/favorites-fs/constants";
import { useSyncItemsWithFavoritesContext } from "src/website-apps/shared/utils/favorites-utils";

const HEADER_CONTENT_ID = "cid$#3521817#";
const CAROUSEL_NAME = "saved-events";
const CAROUSEL_METHOD = "UserSubscriptions";
const ENDPOINT_PATH = "/favorites";
const PAGE_SIZE = 12;

const CarouselWidthController = ({ children }) => (
  <div style={{ overflowX: "hidden", padding: "0 20px", margin: "0 -20px" }}>{children}</div>
);

const Container = styled.div`
  display: grid;
  grid: auto / 1fr;
  gap: var(--carousel-header-gap, ${({ theme }) => theme.spacing(4)});
  margin-top: 0;
  @media only screen and (min-width: ${({ theme }) => theme.media.breakpoints.md}px) {
    gap: var(--carousel-header-gap, ${({ theme }) => theme.spacing(6)});
    margin-top: 0;
  }
`;

const Title = styled(Heading)`
  font-style: normal;
  font-weight: 700;
  color: #091218; // not present in core at time of implementation
  font-size: 20px;
  line-height: 24px;
  @media ${({ theme: { media } }) => `${media.tablet}, ${media.desktop}`} {
    font-size: 24px;
    line-height: 28px;
  }
  margin: 0;
`;

export const SavedEventsOnHome = ({ size, initialEvents, itemsRevision }) => {
  const hasEvents = (initialEvents?.items?.length ?? 0) > 0;

  useSyncItemsWithFavoritesContext(initialEvents?.items);

  if (!initialEvents) {
    return <CarouselSkeleton />;
  }

  if (!hasEvents) {
    return null;
  }

  return (
    <Container>
      <Title>
        <Content id={HEADER_CONTENT_ID} />
      </Title>
      <CarouselWidthController>
        <FavoriteEventsCarousel
          id={CAROUSEL_NAME}
          method={CAROUSEL_METHOD}
          pageSize={PAGE_SIZE}
          carouselName={CAROUSEL_NAME}
          initialEvents={initialEvents}
          itemsRevision={itemsRevision}
          additionalFetchParams={[["subscriptionType", ENTITY_TYPES.EVENT]]}
          headerName={CAROUSEL_NAME}
          path={ENDPOINT_PATH}
          size={size}
          analyticsCarouselId={CarouselId.SavedEvents}
        />
      </CarouselWidthController>
    </Container>
  );
};
